import XmlSubTitleParser from './xmlSubtitleParser';

class BookProvider {
  constructor() {
    this.book = null;
  }

  load = async () => {
    const res = await fetch(process.env.PUBLIC_URL + '/book.json');
    const book = await res.json();
    this.book = book;
  };

  get = async () => {
    if (this.book === null) {
      await this.load();
    }
    return this.book;
  };

  getScore = async scoreName => {
    if (this.book === null) {
      await this.load();
    }

    const scores = this.book.chapters
      .map(chapter => {
        return chapter.scores[scoreName];
      })
      .filter(item => item);
    return scores ? scores[0] : null;
  };

  getSubtitles = async scoreName => {
    if (this.book === null) {
      await this.load();
    }
    //TODO: read from file.
    const score = await this.getScore(scoreName);
    const subtitleParser = new XmlSubTitleParser(score);
    const subtitles = await subtitleParser.parse();
    return subtitles;
  };

  getMusicUrls = score => {
    let baseUrl = null;
    let melodyUrl = null;
    if (score.type === 'dir') {
      baseUrl = '/music' + score.path + '/base.mp3';
      melodyUrl = '/music' + score.path + '/melodia.mp3';
    }
    console.log(score, baseUrl, melodyUrl)
    return { baseUrl, melodyUrl };
  };
}

const instance = new BookProvider();

export default instance;
